import { Component, DestroyRef, Input, OnInit, inject } from '@angular/core';
import { CompanyService } from '../../../services/company.service';
import { SmartphotoStatusDetails } from '../../../entities/types/smartphoto-status-details.type';
import { SmartphotoService } from '../../../services/smartphoto.service';
import { CardFieldWithValue } from '../../../entities/types/smartphoto-card-field.type';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { CaseService } from '../../../services/case.service';
import { Smartphoto } from '@bdeo-motor/smartphoto-entities';

@Component({
  selector: 'app-smartphoto-card',
  templateUrl: './smartphoto-card.component.html',
  styleUrls: ['./smartphoto-card.component.scss']
})
export class SmartphotoCardComponent implements OnInit {
  @Input({ required: true }) smartphoto?: Smartphoto;

  private readonly companyService = inject(CompanyService);
  private readonly smartphotoService = inject(SmartphotoService);
  private readonly caseService = inject(CaseService);
  private readonly destroyRef = inject(DestroyRef);

  public hasDeadline$ = this.companyService.hasDeadline$;
  public smartphotoStatusDetails?: SmartphotoStatusDetails;
  public cardFields: CardFieldWithValue[] = [];

  ngOnInit(): void {
    this.companyService.cardFields$.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(async (fields) => {
      if (!this.smartphoto || !fields) {
        return;
      }

      const caseObject = await this.caseService.getByNumber(this.smartphoto.caseRef);

      const smartphotoMap = new Map(Object.entries(this.smartphoto));
      const caseMap = new Map(Object.entries(caseObject));

      this.cardFields = fields.map((field) => {
        return {
          ...field,
          value: (field.origin === 'case' ? caseMap.get(field.fieldName) : smartphotoMap.get(field.fieldName)) ?? '-'
        };
      });
    });

    this.smartphotoStatusDetails = this.smartphotoService.getSmartphotoStatusDetails(this.smartphoto);
  }
}
